/**
 * @fileoverview Org portal — Settings › You › Preferences
 * (/org/settings/account; "Your account" until November 2026, the path kept so
 * links and the emails' "Turn off" links keep working).
 *
 *  - Notifications: the emails you receive, each switched for yourself
 *    (`OrgEmailPreferences`).
 *  - Account: your own password, and deleting your own account, which the
 *    server refuses while you are the organization's only active
 *    administrator (App Review 5.1.1(v)). Both were a card on the Admins page
 *    until iOS review C10 put what is yours apart from the organization.
 *
 * The admins are read only to say, before you try, that deleting has to wait
 * for another admin; until they are read, or when they cannot be, the
 * server's answer decides.
 */

import { useContext, useEffect, useState } from "react";
import { OrgAuthContext } from "@/App";
import orgApi from "@/lib/orgApi";
import { Card, SectionHeader } from "@/components/studio/primitives";
import OrgChangePassword from "@/components/org/OrgChangePassword";
import OrgDeleteAccount from "@/components/org/OrgDeleteAccount";
import OrgEmailPreferences from "@/components/org/OrgEmailPreferences";

export default function OrgAccountPage() {
  const { admin: me } = useContext(OrgAuthContext) || {};
  const [otherActiveAdmins, setOtherActiveAdmins] = useState(null);

  useEffect(() => {
    let on = true;
    orgApi
      .get("/org/admins")
      .then((resp) => {
        const admins = resp.data?.admins || [];
        if (on) setOtherActiveAdmins(admins.filter((a) => a.admin_id !== me?.admin_id && a.active).length);
      })
      .catch(() => {
        if (on) setOtherActiveAdmins(null);
      });
    return () => {
      on = false;
    };
  }, [me?.admin_id]);

  return (
    <div data-testid="org-account-page">
      <h1 className="mb-6 font-serif text-2xl font-semibold text-[var(--text-primary)]">Preferences</h1>
      <OrgEmailPreferences />
      <SectionHeader>Account</SectionHeader>
      <Card>
        <OrgChangePassword />
        <OrgDeleteAccount otherActiveAdmins={otherActiveAdmins} />
      </Card>
    </div>
  );
}
